<template>
    <b-form-group>
        <b-dropdown class="room-picker" variant="white" block no-caret>
            <template #button-content>
                <b-icon icon="people" aria-hidden="true"></b-icon> {{ buttonTitle }}
            </template>
            <div class="room-picker-wrap">
                <div class="room-filters">
                    <label class="label" for="adults-input">{{ $t('Adults') }}</label>
                    <Quantity inputName="adults"
                        @child-quantity="changeAdults"
                        :inputValue="value.adults"
                        minValue="1"
                        maxValue="32"
                    />
                </div>
                <div class="room-filters">
                    <label class="label" for="children-input">{{ $t('Children') }}</label>
                    <Quantity 
                        inputName="children"
                        @child-quantity="changeChildren" 
                        :inputValue="value.children"
                        minValue="0"
                        maxValue="32"
                    />
                </div>
                <div v-if="value.children" class="room-filters" style="display: block">
                    <label class="label">{{ $t('Children\'s age') }}</label>
                    <b-row>
                        <b-col v-for="child in this.value.children" :key="child" lg="4" md="4" class="mb-3">
                            <b-form-select
                                v-model="value.ages[child - 1]"
                                :options="childAgeOptions"
                                required>
                            </b-form-select>
                        </b-col>
                    </b-row>
                    <p><small>{{ $t('In order to find a place for your whole group to stay and to be able to show the correct price, we need to know how old your children are at the time of check-out') }}</small></p>
                </div>
                <div class="room-filters">
                    <label class="label" for="rooms-input">{{ $t('Rooms') }}</label>
                    <Quantity 
                        inputName="rooms" 
                        @child-quantity="changeRooms"
                        :inputValue="value.rooms"
                        minValue="1"
                        maxValue="8"
                    />
                </div>
            </div>
        </b-dropdown>
    </b-form-group>
</template>

<script>
    import Quantity from '@/components/ui/Quantity.vue'

    export default {
        name: "OccupationPicker",
        props: {
            value: {
                type: Object,
                required: true
            }
        },
        components: {
            Quantity,
        },
        data() {
            return {
                childAgeOptions: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17'],
            };
        },
        methods: {
            changeAdults(quantity) {
                this.value.adults = quantity;
                this.sendEmit();
            },
            changeChildren(quantity) {
                this.value.children = quantity;
                if (this.value.ages.length > quantity) {
                    this.value.ages.pop();
                } else if (this.value.ages.length < quantity) {
                   this.value.ages.push(1);
                }
                this.sendEmit();
            },
            changeRooms(quantity) {
                this.value.rooms = quantity;
                this.sendEmit();
            },
            sendEmit() {
                this.$emit("occupation", this.value);
            }
        },
        computed: {
            buttonTitle: function() {
                var string = '';
                
                var guests = this.value.adults + this.value.children;
                string += guests;
                if (guests == 0) {
                    string += ' guests, ';
                } else if (guests > 1) {
                    string += ' guests, ';
                } else {
                    string += ' guest, ';
                }

                string += this.value.rooms;
                if (this.value.rooms == 0) {
                    string += ' rooms ';
                } else if (this.value.rooms > 1) {
                    string += ' rooms ';
                } else {
                    string += ' room ';
                }

                return string;
            }
        }
    };
</script>

<style>
    @media screen and (min-width:991px) {
        .room-picker button{
            border-radius:0px !important;
        }
    }
    .room-picker > button.btn-white{
        border:1px solid #ced4da;
        background-color:#fff;
    }
    .stay-widget .custom-select{
        font-size:1em;
    }
    .stay-widget label{
        font-size:1em;
    }
</style>
<style scoped>
    .room-picker-wrap {
        padding: 15px;
        width: 300px;
    }

    .room-filters {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
    }
</style>